const officeProfileMixin = {
    methods: {
        checkOfficeTiming( officeId, params ) {
            return this.axios.get( this.$config.urls.office.checkTiming.url.replace( ':id', officeId ), { params: params } );
        }
    }
};
export default officeProfileMixin;